<template>
  <div class="full-page auth" data-test="choose-user__page">
    <Modal>
      <template v-if="!selectedUser">
        <h1 class="title title--3">Choisir un compte</h1>
        <div class="dataTable" v-loading="loading">
          <div
            v-for="user in users"
            :key="user.id"
            class="dataTable__item"
            @click="handleChooseUserToLogin(user)"
          >
            <strong class="user__name">{{ user.displayName }}</strong>
            <small class="user__position">{{ user.displayTitle }}</small>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="dataTable__arrow">
              <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6
              0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9
              0l136 136c9.5 9.4 9.5 24.6.1 34z"/>
            </svg>
          </div>
        </div>
      </template>
      <template v-else-if="selectedUser && resetingPassword">
        <Button
          size="sm"
          theme="secondary"
          class="cancelButton"
          @click.native="resetingPassword = false"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1
            1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                  clip-rule="evenodd" />
          </svg>
          <span>Retour</span>
        </Button>
<!--        TODO : SWAP OPENBAR UPDATE: -->
<!--        <h1 class="title title&#45;&#45;3">-->
<!--          Attention !-->
<!--        </h1>-->
<!--        <p class="subtitle">-->
<!--          Votre compte sera suspendu tant que votre manager de secteur-->
<!--          n’aura pas confirmé votre demande.-->
<!--        </p>-->
        <ForgotPasswordForm
          :invalidPassword="userResetPasswordIsInvalid"
          :invalidConfirmationPassword="userResetConfirmPasswordIsInvalid"
          :loading="resetPasswordRequest"
          @resetPassword="submitResetPasswordRequest"
        />
      </template>
      <template v-else>
        <Button size="sm" theme="secondary" @click.native="resetUser" class="cancelButton">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1
            1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
            clip-rule="evenodd" />
          </svg>
          <span>Retour</span>
        </Button>
        <h1 class="title title--3">
          Ravi de vous revoir <strong>{{ selectedUser.firstname }}</strong> !
        </h1>
        <p class="subtitle">Utilisez votre mot de passe pour vous connecter.</p>
        <LoginForm
          :disabled="selectedUser.hasActivePasswordRequest"
          :loading="connecting"
          :invalid="userPasswordIsInvalid"
          @onLogin="handleLogin"
          @forgotPassword="toggleForgotPassword"
        />
      </template>
    </Modal>
  </div>
</template>

<script>
import services from 'services';
import axios from 'axios';
import Modal from '@/components/Modal.vue';
import Button from '@/components/Button.vue';
import LoginForm from '@/views/pages/UserLoginPage/LoginForm.vue';
import ForgotPasswordForm from '@/views/pages/UserLoginPage/ForgotPasswordForm.vue';

export default {
  props: {
    responseType: { type: String, required: true },
    clientId: { type: String, required: true },
    redirectUri: { type: String, required: true },
    scope: { type: String, required: true },
    state: { type: String, required: true },
    acrValues: { type: Object, required: true },
    codeChallenge: { type: String, required: true },
  },
  components: {
    Modal,
    Button,
    LoginForm,
    ForgotPasswordForm,
  },
  async mounted() {
    this.loading = true;
    const { shopToken } = this.acrValues;
    if (!shopToken) {
      await this.$alert('Le magasin ne peut être authentifié.');
    }
    await this.fetchData(shopToken);
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      userPassword: '',
      users: [],
      selectedUser: null,
      userPasswordIsInvalid: false,
      resetingPassword: false,
      userResetPasswordIsInvalid: false,
      userResetConfirmPasswordIsInvalid: false,
      resetPasswordRequest: false,
      connecting: false,
    };
  },
  methods: {
    async fetchData(shopToken) {
      this.users = await services.shopAuthService.listAllUsers(shopToken);
    },
    resetSelectedUser() {
      this.selectedUser = null;
    },
    handleChooseUserToLogin(user) {
      console.log('user');
      this.selectedUser = user;
    },
    async verifyLogin(email, password) {
      await axios.post(`${process.env.VUE_APP_BACKEND_URL}/oidc/interaction/verify-login`, {
        email,
        password,
      });
    },
    async handleLogin({ password }) {
      this.userPasswordIsInvalid = false;

      try {
        this.connecting = true;

        const { email } = this.selectedUser;

        this.$mixpanel.track('Connexion utilisateur', { email: this.selectedUser.email, oidc: true });

        const { query } = this.$route;
        delete query.display;

        await this.verifyLogin(email, password);
        // await this.$message.success('Connexion réussie');
        return this.postLoginForm(email, password);
      } catch (e) {
        console.log(e);
        this.connecting = false;
        this.loading = false;

        if (e.response.status === 401) {
          this.userPasswordIsInvalid = true;
          return undefined;
        }
        return this.$message.error('Une erreur est survenue, veuillez réessayer');
      }
    },
    createForm(actionUrl, name) {
      const form = document.createElement('form');
      // form.setAttribute('target', '_blank');
      form.setAttribute('method', 'post');
      form.setAttribute('name', name);
      form.setAttribute('action', actionUrl);
      return form;
    },
    generateHiddenFormAttribute(form, { name, value }) {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', name);
      hiddenField.setAttribute('value', value);
      form.appendChild(hiddenField);
    },
    postLoginForm(email, password) {
      const form = this.createForm(`${process.env.VUE_APP_BACKEND_URL}/oidc/interaction/login`, 'login');

      this.generateHiddenFormAttribute(form, { name: 'email', value: email });
      this.generateHiddenFormAttribute(form, { name: 'password', value: password });
      this.generateHiddenFormAttribute(form, { name: 'client_id', value: this.clientId });
      this.generateHiddenFormAttribute(form, { name: 'redirect_uri', value: this.redirectUri });
      this.generateHiddenFormAttribute(form, { name: 'code_challenge', value: this.codeChallenge });
      this.generateHiddenFormAttribute(form, { name: 'state', value: this.state });

      document.body.appendChild(form);
      form.submit();
    },
    toggleForgotPassword() {
      this.resetingPassword = true;
    },
    showResetPasswordSuccessMessage() {
      // TODO : SWAP OPENBAR UPDATE
      // this.$message.success(this.$t('resetPasswordForm.requestSentForApproval'));
      this.$message.success('Mot de passe réinitialisé !');
    },
    verifyPasswords(password, confirmPassword) {
      if (!password.match(/^[0-9]{8}$/)) {
        this.userResetPasswordIsInvalid = true;
      }
      if (password !== confirmPassword) {
        this.userResetConfirmPasswordIsInvalid = true;
      }
      return this.userResetPasswordIsInvalid || this.userResetConfirmPasswordIsInvalid;
    },
    async submitResetPasswordRequest({ password, confirmPassword }) {
      this.userResetPasswordIsInvalid = false;
      this.userResetConfirmPasswordIsInvalid = false;
      if (this.verifyPasswords(password, confirmPassword)) {
        return undefined;
      }
      try {
        this.resetPasswordRequest = true;
        this.$mixpanel.track('Demande de nouveau mot de passe', { userId: this.selectedUser.id });
        const authService = new services.AuthService(
          this.$store.getters['auth/authenticatedUserIdToken'],
          this.$store.getters['shopAuth/authenticatedShopToken'],
        );
        const { shopToken } = this.acrValues;
        await authService.sendResetPasswordRequest(this.selectedUser.id, password, shopToken);
        this.resetPasswordRequest = false;
        await this.fetchData(shopToken);
        this.resetingPassword = false;
        this.resetSelectedUser();
        return this.showResetPasswordSuccessMessage();
      } catch (e) {
        this.resetPasswordRequest = false;
        if (e.response.status === 401) {
          this.userResetPasswordIsInvalid = true;
          return undefined;
        }
        return this.$message.error('Une erreur est survenue, veuillez réessayer');
      }
    },
    resetUser() {
      this.selectedUser = null;
    },
  },
};
</script>

<style scoped>
.modal {
  position: relative;
}
.button.cancelButton {
  position: absolute;
  top: var(--size-1);
  left: var(--size-1);
}
.button.cancelButton svg {
  width: 1rem;
}
</style>
